import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const AppointmentsIcon = createSvgIcon(
 <svg
  fill="currentColor"
  height="800px"
  width="800px"
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 392.598 392.598"
  xmlSpace="preserve">
  <g>
   <g>
    <path
     d="M61.899,284.509h-7.305c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.848,10.925-10.925S67.976,284.509,61.899,284.509z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M120.404,284.509h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.848,10.925-10.925S126.416,284.509,120.404,284.509z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M178.844,284.509h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.848,10.925-10.925S184.857,284.509,178.844,284.509z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M61.899,237.317h-7.305c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C72.889,242.166,67.976,237.317,61.899,237.317z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M120.404,237.317h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C131.329,242.166,126.416,237.317,120.404,237.317z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M178.844,237.317h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C189.77,242.166,184.857,237.317,178.844,237.317z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M61.899,190.061h-7.305c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.848,10.925-10.925S67.976,190.061,61.899,190.061z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M120.404,190.061h-7.37c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.848,10.925-10.925S126.416,190.061,120.404,190.061z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M178.844,190.061h-7.37c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.848,10.925-10.925S184.857,190.061,178.844,190.061z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M237.35,189.996h-7.37c-6.012,0-10.925,4.848-10.925,10.925c0.065,6.077,4.913,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.848,10.925-10.925S243.426,189.996,237.35,189.996z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M61.899,142.869h-7.305c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.796,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C72.76,147.717,67.976,142.869,61.899,142.869z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M120.404,142.869h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C131.329,147.717,126.416,142.869,120.404,142.869z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M178.844,142.869h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.849,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C189.705,147.717,184.857,142.869,178.844,142.869z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M295.79,142.804h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0,6.077,4.913,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C306.715,147.717,301.867,142.804,295.79,142.804z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M237.35,142.804h-7.37c-6.012,0-10.925,4.849-10.925,10.925c0.065,6.077,4.913,10.925,10.925,10.925h7.37
           c6.012,0,10.925-4.849,10.925-10.925C248.275,147.717,243.426,142.804,237.35,142.804z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M350.287,227.297V59.604c0-18.036-14.675-32.711-32.711-32.711h-33.228V10.925C284.348,4.913,279.499,0,273.422,0
           c-6.012,0-10.925,4.848-10.925,10.925v16.032H87.758V10.99c0-6.012-4.849-10.925-10.925-10.925S65.907,4.913,65.907,10.99v15.968
           H32.743c-18.036,0-32.711,14.675-32.711,32.711V317.22c0,18.036,14.675,32.711,32.711,32.711h194.263
           c15.774,25.6,43.96,42.667,76.089,42.667c49.325,0,89.471-40.081,89.471-89.471C392.566,271.127,375.628,243.071,350.287,227.297z
            M21.818,59.604c0-6.012,4.848-10.925,10.925-10.925h33.228v17.778c0,6.012,4.849,10.925,10.925,10.925
           c6.012,0,10.925-4.848,10.925-10.925V48.679h174.869v17.778c0,6.012,4.849,10.925,10.925,10.925
           c6.012,0,10.925-4.848,10.925-10.925V48.679h33.228c6.012,0,10.925,4.849,10.925,10.925v39.564H21.818V59.604z M217.309,328.21
           l-184.501-0.065c-6.012,0-10.925-4.848-10.925-10.925V121.083h306.683v96.388c-8.016-2.392-16.614-3.685-25.406-3.685
           c-49.325,0-89.471,40.081-89.471,89.471C213.689,311.919,214.982,320.323,217.309,328.21z M303.095,370.812
           c-37.301,0-67.685-30.384-67.685-67.685s30.384-67.685,67.685-67.685s67.685,30.384,67.685,67.685
           S340.396,370.812,303.095,370.812z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M339.879,276.105c-4.331-4.267-11.313-4.267-15.515,0l-30.901,30.901l-11.572-11.572c-4.267-4.267-11.119-4.267-15.451,0
           c-4.267,4.267-4.267,11.119,0,15.451l19.329,19.329c5.56,5.495,13.382,2.004,15.451,0l38.659-38.659
           C344.145,287.289,344.145,280.436,339.879,276.105z"
    />
   </g>
  </g>
 </svg>,
 "Appointments"
);
